import {
  getMembershipState,
  getMembershipStateAsync,
  MEMBERSHIP_STATES,
  isLoggedIn,
  isLoggedInAsync,
  hasActiveAnnualMembership,
  hasActiveAnnualMembershipAsync,
} from '@mc/user-info'

declare global {
  interface Window {
    hj?: (event: string, triggerName: string) => void
  }
}

export const TRIGGER_NAMES = {
  SUBSCRIBER: {
    LOGGED_OUT: 'logged_out',
    LOGGED_IN_NO_SUBSCRIPTION: 'logged_in_no_subscription',
    LOGGED_IN_WITH_SINGLE_CLASS: 'logged_in_with_single_class',
    LOGGED_IN_WITH_AAP: 'logged_in_with_aap',
  },
  CHECKOUT: {
    CART_START: 'cart_start',
    EXIT_CART: 'exit_cart',
  },
}

const getSubscriberType = () => {
  if (!isLoggedIn()) {
    return TRIGGER_NAMES.SUBSCRIBER.LOGGED_OUT
  }

  if (hasActiveAnnualMembership()) {
    return TRIGGER_NAMES.SUBSCRIBER.LOGGED_IN_WITH_AAP
  }

  if (getMembershipState() === MEMBERSHIP_STATES.SINGLE_CLASS) {
    return TRIGGER_NAMES.SUBSCRIBER.LOGGED_IN_WITH_SINGLE_CLASS
  }

  return TRIGGER_NAMES.SUBSCRIBER.LOGGED_IN_NO_SUBSCRIPTION
}

const getSubscriberTypeAsync = async () => {
  if (await !isLoggedInAsync()) {
    return TRIGGER_NAMES.SUBSCRIBER.LOGGED_OUT
  }

  if (await hasActiveAnnualMembershipAsync()) {
    return TRIGGER_NAMES.SUBSCRIBER.LOGGED_IN_WITH_AAP
  }

  if ((await getMembershipStateAsync()) === MEMBERSHIP_STATES.SINGLE_CLASS) {
    return TRIGGER_NAMES.SUBSCRIBER.LOGGED_IN_WITH_SINGLE_CLASS
  }

  return TRIGGER_NAMES.SUBSCRIBER.LOGGED_IN_NO_SUBSCRIPTION
}

export const identifySubscriber = () => {
  const subscriberType = getSubscriberType()
  triggerHotjar(subscriberType)
}

export const identifySubscriberAsync = async () => {
  const subscriberType = await getSubscriberTypeAsync()
  triggerHotjar(subscriberType)
}

export const triggerHotjar = (triggerName: string) => {
  if (typeof window.hj === 'function') {
    window.hj('event', triggerName)
  }
}
